import React from 'react';
import SetupRouters from './router/setupRouter';

function App() {
  return (
    <SetupRouters/>
  );
}

export default App;